module.exports = __webpack_public_path__ + "resources/img/img_tibero5_m_jp.0abac52675a81e4983c1e1ec0feb93ed.png";